import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ThemePalette } from "@angular/material/core";
import {NgClassType} from "../../model/common.model";
import {NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";


@Component({
  selector: 'quick-preview-panel',
  templateUrl: './quick-preview-panel.component.html',
  imports: [
    NgClass,
    NgIf,
    MatToolbarModule,
    NgTemplateOutlet,
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ],
  standalone: true
})
export class QuickPreviewPanelComponent implements OnInit {

  @Input() heading?: string
  @Input() content?: any
  @Input() contentTemplate?: TemplateRef<{ content: any }>
  @Input() color?: ThemePalette
  @Input() headingIconKey?: string
  @Input() headingPrefixTemplate?: TemplateRef<any>
  @Input() headingSuffixTemplate?: TemplateRef<any>
  @Input() collapsable: boolean = false
  @Input() collapsed: boolean = false
  @Input() dismissible: boolean = false
  @Input() useFlashOnHover: boolean = false
  @Input() ngClass: NgClassType
  @Input() toolbarEndTemplate?: TemplateRef<any>
  @Output() toggleExpandCollapse = new EventEmitter<boolean>()
  @Output() toggleDismissed = new EventEmitter<{
    sender: QuickPreviewPanelComponent,
    args: {
      dismissed: boolean,
      dismissReason?: string
    }
  }>()

  dismissed = false

  constructor() {
  }

  ngOnInit(): void {
  }

  dismissibleClick() {
    this.dismissed = true
    this.toggleDismissed.emit({
      sender: this,
      args: {
        dismissed: this.dismissed,
        dismissReason: 'Dismiss button click'
      }
    })
  }
}
